module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mywallet/card/cardlist/cardlist.component.css
// module id = ./src/app/mywallet/card/cardlist/cardlist.component.css
// module chunks = main